var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.000000, -488.000000) translate(20.000000, 488.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6 4H18V20H6z",
    transform: "translate(8.000000, 8.000000)",
    className: "invert-dark"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M18 2c1.105 0 2 .895 2 2v16c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h12zm0 2H6v16h12V4zm-6 13c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z",
    transform: "translate(8.000000, 8.000000)",
    className: "invert-light"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-mobile.fbe6fa046179cc23a73e65038ba4f454.svg";